import { memo } from "react";
import OwnerMilkrecordingSelect from "../../components/multiforms/OwnerMilkrecordingSelect";

const SelectMilkRecording = () => {
    return (
        <OwnerMilkrecordingSelect type={"SelectMilkrecording"} />
    )
}

export default memo(SelectMilkRecording);